export enum DeviceHistoryEntryField {
    DEVICE_ID = "deviceId",
    TIMESTAMP = "timestamp",
    ORGANIZATION_ID = "organizationId",
    ORGANIZATION_NAME = "organizationName",
    TYPE = "type",
    SEVERITY = "severity",
    INFORMATION = "information",
    USER_COMMENT = "userComment",
    STAGE_IDENTIFIER = "stageIdentifier",
    STAGE_DESCRIPTION = "stageDescription",
    USER_ID = "userId",
    USER_TAG = "userTag",
    JOB_ID = "jobID",
    FIRMWARE_VERSION = "firmwareVersion",
}

export interface DeviceHistoryEntry {
    [DeviceHistoryEntryField.DEVICE_ID]: string;
    [DeviceHistoryEntryField.TIMESTAMP]: string;
    [DeviceHistoryEntryField.ORGANIZATION_ID]: string;
    [DeviceHistoryEntryField.ORGANIZATION_NAME]: string;
    [DeviceHistoryEntryField.TYPE]: DeviceHistoryEntryType;
    [DeviceHistoryEntryField.SEVERITY]: DeviceHistorySeverity;
    [DeviceHistoryEntryField.INFORMATION]: string;
    [DeviceHistoryEntryField.USER_COMMENT]: string;
    [DeviceHistoryEntryField.STAGE_IDENTIFIER]: string;
    [DeviceHistoryEntryField.STAGE_DESCRIPTION]: string;
    [DeviceHistoryEntryField.USER_ID]: number;
    [DeviceHistoryEntryField.USER_TAG]: string;
    [DeviceHistoryEntryField.JOB_ID]: string;
    [DeviceHistoryEntryField.FIRMWARE_VERSION]: string;
}

export enum DeviceHistorySeverity {
    INFO = 0,
    WARN = 1,
    ERROR = 2,
}

export enum DeviceHistoryEntryType {
    FIRMWARE_CHANGED = "firmwareChanged",
    FIRMWARE_UPDATE_SCHEDULED = "firmwareUpdateScheduled",
    FIRMWARE_UPDATE_STATUS = "firmwareUpdateStatus",
    CHECKIN = "checkin",
    DEVICE_ASSIGNMENT = "deviceAssignment",
    RDL_AUTH = "rdlAuth",
    LAST_WILL = "lastWill",
    FIRMWARE_UPDATE = "firmwareUpdate",
    LAS_SYS = "lastSystemState",
    DTCO = "dtcoInfo",
}

export enum DeviceCommand {
    RESET = "reset",
    REQUEST_LOCATION = "request_location",
    CANCEL_FIRMWARE_UPDATE = "cancel_firmware_update",
}
